export const ITEMS_PER_PAGE = 15;

export const eventTypeOrderSmSe = {
    Alarm: 0,
    Alert: 1
};

export const pageSize = 10000;
